<template>
  <page-layout id="add-class-page" :title="addNew">
    <main-information @on-submit="addNewGradeScale" ref="formRef">
      <!-- <template #footer-actions> -->
      <!-- <div class="form-actions text-center">
          <md-button class="md-raised" @click="goToPreviousPage"
            >Cancel</md-button
          >
          <md-button type="submit" class="md-success ml-4">Add</md-button>
        </div> -->
      <!-- </template> -->
    </main-information>
  </page-layout>
</template>

<script>
import { MainInformation } from "../Forms";
import PageLayout from "@/pages/PageLayout.vue";
import { service_paths } from "@/constants/Services";
import { Message, hasHistory } from "@/helpers/utils";
import { grade_scale_router_names } from "@/routes/routes";

export default {
  components: { MainInformation, PageLayout },
  data() {
    return {};
  },
  computed: {
    addNew() {
      return this.$t("grade_scale.add_new");
    }
  },
  methods: {
    addNewGradeScale(formData) {
      console.log("add_form_data: ", formData);
      this.$axios.post(`${service_paths.grade_scales}`, formData).then(() => {
        Message.success(this.$t("common.add_success"));
        this.$router.push({ name: grade_scale_router_names.listPage });
      });
    }
    // clearForm() {
    //   this.$refs.formRef.clearForm();
    // },
  }
};
</script>
